// extracted by mini-css-extract-plugin
export default {"Button_circle":"Button_circle_Button_circle__r+JFU","text":"Button_circle_text__lqyri"};